goog.provide("shadow.js.shim.module$$mui$material$Grid$default");
shadow.js.shim.module$$mui$material$Grid$default = shadow.js.shim.module$$mui$material$Grid.default;
